import { Stack } from "@mui/material";
import { ReactNode } from "react";

/** Props for the MobileActionBar component. */
interface Props {
  /** Optional search component. */
  renderSearch?: () => ReactNode;
  /** Optional sort component. */
  renderSort?: () => ReactNode;
  /** Optional export component. */
  renderExport?: () => ReactNode;
}

/**
 * Renders an action bar for mobile list views with optional search, sort and action components.
 * Appears above the list items and provides a consistent layout for common list operations.
 */
export function MobileActionBar({
  renderSearch,
  renderSort,
  renderExport,
}: Props): JSX.Element {
  return (
    <Stack gap={1.5} mt={1.5} mb={2.25}>
      {/* Search row */}
      {renderSearch && <Stack width="100%">{renderSearch()}</Stack>}

      {/* Sort and Actions row */}
      {(renderSort || renderExport) && (
        <Stack
          flexDirection="row"
          justifyContent="space-between"
          alignItems="center"
          gap={1}
        >
          {renderSort && <Stack flex={1}>{renderSort()}</Stack>}
          {renderExport && <Stack>{renderExport()}</Stack>}
        </Stack>
      )}
    </Stack>
  );
}
